import React, { 
  createContext, 
  ReactNode, 
  Context,
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { useLocalStorage } from 'usehooks-ts';

type ContextProviderProps = {children : ReactNode} 

export const GlobalContext: Context<any> = createContext("globalContext");
export const GlobalContextProvider = ({ children }: ContextProviderProps) => {
  // const [theme, setTheme] = useLocalStorage<Mode>("theme", Mode.Light)
  // const [driverId, setDriverId] = useLocalStorage<string>("driverId", "");
    const [ userAttributes, setUserAttributes ] = useLocalStorage("userAttributes", {})
    const [authRedirect, setAuthRedirect] = useLocalStorage("authRedirect", "/")
  return (
      <GlobalContext.Provider value={{ 
        // theme, setTheme, 
        userAttributes, setUserAttributes,
        authRedirect, setAuthRedirect,
      }}>
          {children}
      </GlobalContext.Provider>
  );
};


export const ContentContext: Context<any> = createContext("contentContext");
export const ContentContextProvider = ({ children }: ContextProviderProps) => {
  const [activeSeriesSection, setActiveSeriesSection] = useState();

  return (
      <ContentContext.Provider value={{ 
        activeSeriesSection, setActiveSeriesSection, 
      }}>
          {children}
      </ContentContext.Provider>
  );
};